module.exports = __webpack_public_path__ + "static/media/gmr_ground_active.751f2362.svg";